import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTenant } from "../actions/common";
import { TENANT_UTILS, MSGS, TENANT_CODES } from "../utils/tenants";

const useTenantHook = () => {
  const dispatch = useDispatch();
  const currentTenant = useSelector((state) => state.common.currentTenant);

  const getTenantDataByKey = (key) => currentTenant?.[key];

  const currentTenantCode = useMemo(
    () => getTenantDataByKey("code"),
    [currentTenant]
  );

  const instantiateTenant = () => {
    const tenantInfo = TENANT_UTILS.getTenantFromCache();
    if (tenantInfo) {
      return Promise.resolve(
        dispatch(setCurrentTenant(JSON.parse(tenantInfo)))
      );
    }
    return Promise.reject(MSGS.MISSING_TENANT);
  };

  return {
    currentTenant,
    currentTenantCode,
    instantiateTenant,
    isHubspot: currentTenantCode === TENANT_CODES.HUBSPOT,
    isUpGrad: currentTenantCode === TENANT_CODES.UPGRAD,
    isKHTenant: currentTenantCode === TENANT_CODES.KH,
    isLCTenant: currentTenantCode === TENANT_CODES.LC,
    isStudyAbroad: currentTenantCode === TENANT_CODES.STUDY_ABROAD,
    isUgLift: currentTenantCode === TENANT_CODES.UG_LIFT,
    isLcTenant: currentTenantCode === TENANT_CODES.LC,
    getTenantDataByKey,
  };
};

export default useTenantHook;
